import { CoverageMap } from '../../components/geospatial-intelligence-page';
import type { GeospatialMapAreaSelection } from '../../components/geospatial-intelligence-page';
import type { UnitCoverageState } from '../../hooks/useUnitCoverage';

interface GeospatialMapSectionProps {
  showAllRisks: boolean;
  country: string;
  city: string;
  sourceType: string;
  originator: string;
  operatingMode: string;
  riskCategory: string;
  impactTarget: string;
  publicationFromDayMs: number;
  publicationToDayMs: number;
  unitCoverage: UnitCoverageState;
  onRawRisksLoaded: (risks: import('../../types/api').Risk[]) => void;
  onToggleAvailable: (available: boolean) => void;
  onSelectionChange: (selection: GeospatialMapAreaSelection) => void;
}

export function GeospatialMapSection({
  showAllRisks,
  country,
  city,
  sourceType,
  originator,
  operatingMode,
  riskCategory,
  impactTarget,
  publicationFromDayMs,
  publicationToDayMs,
  unitCoverage,
  onRawRisksLoaded,
  onToggleAvailable,
  onSelectionChange,
}: GeospatialMapSectionProps) {
  return (
    <section
      className="geo-layout__map geo-panel geo-panel--map geospatial-placeholder geospatial-placeholder--primary geospatial-placeholder--fill"
      aria-label="Coverage map"
    >
      <CoverageMap
        showAllRisks={showAllRisks}
        countryFilter={country}
        cityFilter={city}
        sourceType={sourceType}
        originator={originator}
        operatingMode={operatingMode}
        riskCategory={riskCategory}
        impactTarget={impactTarget}
        publicationFromDayMs={publicationFromDayMs}
        publicationToDayMs={publicationToDayMs}
        onRawRisksLoaded={onRawRisksLoaded}
        onMeta={({ toggleAvailable: avail }) => onToggleAvailable(avail)}
        onSelectionChange={onSelectionChange}
        unitCoverage={unitCoverage}
      />
    </section>
  );
}
